// extracted by mini-css-extract-plugin
export default {"reviews":"Reviews--reviews--80d0d5","loader":"Reviews--loader--716d67","empty":"Reviews--empty--3eb312"};